module.exports = __webpack_public_path__ + "img/7.0705f998.png";